import { useEffect, useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion
} from "./base/BaseQuestion";



import { Form } from "antd";
import { StepButton } from "./step-button";

export const Introduce = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 0;
  const [nextStep, setNextStep] = useState();
  return (
    <div>
      <img
        src={require("../assets/images/hiroshima.webp")}
        width="100%"
        height={"100%"}
        className="rounded-lg"
      ></img>
      <div className="text-center my-6">
        <p className="text-4xl font-semibold text-green-600">PHIẾU KHẢO SÁT</p>
      </div>

      <div className="text-left" style={{ textAlign: "justify" }}>
        <p>
          Lời đầu tiên, chúng tôi xin gửi tới Anh/Chị lời chào trân trọng nhất!
        </p >
        <p >Tôi tên là <span className="font-semibold">Cung Hồng Việt</span>, hiện đang là nghiên cứu sinh Tiến sĩ tại Trường Cao học về Đổi mới và Thực hành cho Xã hội Thông minh, Đại học Hiroshima, Hiroshima, Nhật Bản.</p>
        <p>
          Hiện tại, chúng tôi đang tiến hành 1 nghiên cứu có tên {" "}
          <span className="font-semibold">
            “Phát triển Khung Khái Niệm Mở Rộng làm rõ cơ chế Mâu Thuẫn Nhận Thức trong việc lựa chọn Hành Vi Di Chuyển Bền Vững với Môi Trường”.
          </span>{" "}
          Mục tiêu của nghiên cứu này là tìm hiểu các yếu tố tâm lý ảnh hưởng đến hành vi di chuyển bền vững với môi trường của người dân, cụ thể là việc sử dụng hệ thống đường sắt đô thị (sau đây gọi tắt là metro) tại thành phố Hà Nội, Việt Nam.
        </p>
        
        <p>
          Đồng thời, nghiên cứu hướng đến việc đề xuất và xác định các phương án khả thi để áp dụng dịch vụ
          <span className="font-semibold"> Mobility-as-a-Service (MaaS) </span>- một phương thức tích hợp các dịch vụ di chuyển khác nhau (như metro, xe buýt, xe đạp chia sẻ, dịch vụ gọi xe…) thành <span className="font-semibold">một nền tảng duy nhất</span> nhằm nâng cao sự thuận tiện, thông suốt, hiệu quả, tiết kiệm chi phí. Bên cạnh đó, nó khuyến khích người dân sử dụng phương tiện giao thông công cộng và phương tiện giao thông thân thiện với môi trường.
        </p>
        <p>
          Trên cơ sở đó, nghiên cứu đặt mục tiêu xác định xu hướng sử dụng <span className="font-semibold">MaaS</span> (giả định dịch vụ này sẽ được giới thiệu tới người dân trong tương lai) để hỗ trợ việc thúc đẩy hành vi di chuyển thân thiện với môi trường tại thành phố Hà Nội.
        </p>
        <p>
          Các câu hỏi trong Phiếu tập trung vào các
          <span className="font-semibold"> chuyến đi chính hàng ngày </span>của người dân
          <span className="font-semibold"> (đi làm/đi học).</span>
        </p>
        <p>
          Tất cả thông tin thu được trong cuộc khảo sát này chỉ được sử dụng cho mục đích nghiên cứu và tính ẩn danh của người trả lời được đảm bảo tuyệt đối.
        </p>
        <p>
          Chúng tôi mong nhận được sự hỗ trợ của Anh/Chị bằng cách trả lời các câu hỏi trong Phiếu. Sự hợp tác của Anh/Chị là một đóng góp quan trọng cho sự thành công trong nghiên cứu của chúng tôi.
        </p>
      </div>

      <div className="mt-6 rounded-lg border-2 border-green-600 w-fit mx-auto text-center p-4">
        <p>
          Nghiên cứu sinh: <span className="font-semibold">Cung Hồng Việt</span>
        </p>
        <p>Giáo sư hướng dẫn: <span className="font-semibold">AKIMASA FUJIWARA</span></p>
        <p>Điện thoại: (+84) 38 987 0792 / (+81) 80 6931 5382</p>
        <p>Email: cunghongviet@hiroshima-u.ac.jp / hongviet97@gmail.com</p>
        <p>Trường Cao học về Đổi mới và Thực hành cho Xã hội Thông Minh </p>
        <p>Đại học Hiroshima, Nhật Bản</p>
      </div>

      <Form
        onFinish={(value) => handleSubmit(value, nextStep)}
        onFinishFailed={handleFail}
      >
        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>
      <br />
      <br />
      <br />

    </div>

  );
};
